import { Box, Divider, Typography, useTheme } from '@mui/material';
import useQuoteIntakeSetupStore from '@/stores/useQuoteIntakeSetupStore';

export type DynamicQuoteFieldType = { label: string; deductions: boolean };

interface Props {
    isPurchase?: boolean;
    isAlberta?: boolean;
    isTransactionTypeToShow?: boolean;
}

export default function DynamicQuoteStructure(props: Props) {
    const theme = useTheme();
    const [formData] = useQuoteIntakeSetupStore((state) => [state.formData]);
    const isAlberta = props.isAlberta ?? formData.step0.province === 'Alberta';
    const transactionTypesToShow = ['Purchase', 'Refinance', 'PrivateLender'];
    const isTransactionTypeToShow =
        props.isTransactionTypeToShow ??
        transactionTypesToShow.includes(formData.step0.transactionType);
    const isPurchase = props.isPurchase ?? formData.step0.transactionType === 'Purchase';

    const quotingFieldsSingle: DynamicQuoteFieldType[] = [
        {
            label: 'Base Legal Fee',
            deductions: false,
        },
        {
            label: 'Legal fee before tax',
            deductions: false,
        },
        {
            label: 'Discount on Legal Fee',
            deductions: false,
        },
        {
            label: 'Net legal fee',
            deductions: false,
        },
    ];

    quotingFieldsSingle.push({
        label: `${isAlberta ? 'GST' : 'HST'} on legal fee`,
        deductions: false,
    });

    quotingFieldsSingle.push({
        label: `Estimated disbursements with ${isAlberta ? 'GST' : 'HST'}`,
        deductions: false,
    });
    quotingFieldsSingle.push({
        label: 'Estimated registration fees',
        deductions: false,
    });
    if (isTransactionTypeToShow) {
        quotingFieldsSingle.push({
            label: 'Estimated title insurance fee',
            deductions: false,
        });
    }
    if (isPurchase && !isAlberta) {
        quotingFieldsSingle.push({
            label: 'Land transfer tax',
            deductions: true,
        });
        quotingFieldsSingle.push({
            label: 'First time home buyer rebate',
            deductions: true,
        });
    }
    if (isPurchase && !isAlberta) {
        quotingFieldsSingle.push({
            label: 'Net Land Transfer Tax',
            deductions: false,
        });
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {quotingFieldsSingle.map((field) => (
                <Box key={field.label} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 1,
                            gap: '12px',
                        }}
                    >
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography variant="body2" color={theme.palette.neutral.N_500}>
                                {field.label}
                            </Typography>
                            <Typography variant="labelMedium" color={theme.palette.neutral.black}>
                                {field.label === 'Discount on Legal Fee' ? '-$value' : '$value'}
                            </Typography>
                        </Box>
                    </Box>
                    {field.deductions && <Box sx={{ flex: 1 }}></Box>}
                </Box>
            ))}
            <Divider sx={{ margin: '16px 0' }} orientation="horizontal" />
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="labelLarge" color={theme.palette.neutral.N_500}>
                    Quote total:
                </Typography>
                <Typography variant="h3" color={theme.palette.neutral.black}>
                    $value
                </Typography>
            </Box>
        </Box>
    );
}
